export default __webpack_public_path__ + "static/media/instaProfBadgeFalse.93343440.svg";